<div class="contact-container">
    <div class="contact-section">
        <div class="title">
            <div class="main-title yellow-heading">Design your ticker tape for the whole world to see!</div>
        </div>
        <div class="form-section">
            <div class="img-section">
                <img src="../../assets/images/icon 09.jpg" alt="" />
            </div>
            <div class="form" [formGroup]="designerForm">
                <div class="label">Announcement</div>
                <input type="text" formControlName="content" placeholder="Enter you content here!" />
                <input type="email" formControlName="redirect_to"
                    placeholder="Do you wish to redirect the ticker to somewhere else?" />
                <div class="checkbox">
                    <input type="checkbox" formControlName="display" id="display" />
                    <label for="display">Display for all users</label>
                </div>
                <button (click)="onSubmit()">Submit</button>
            </div>
        </div>
    </div>
</div>